import type {
  MissingField,
  PendingStrandLossWarning,
  Process,
} from "../../models/caster.models";

const getDisplayName = ({ strand, heatName }: PendingStrandLossWarning) =>
  heatName === null
    ? `Strand ${strand} Loss Reason`
    : `Strand ${strand} (${heatName}) Loss Reason`;

const createStrandLossReasonMissingField = (
  process: Process,
  warning: PendingStrandLossWarning,
): MissingField => ({
  ProcessId: process.ProcessId,
  HeatId: process.HeatId,
  HeatName: process.HeatName,
  FieldName: `StrandLossReason_${warning.strandLossId}`,
  DisplayName: getDisplayName(warning),
});

export const getStrandLossMissingFields = (
  process: Process,
  warnings: PendingStrandLossWarning[],
): MissingField[] =>
  warnings.map((warning) =>
    createStrandLossReasonMissingField(process, warning),
  );
